<template>
  <section class="padlet-cards-section">
    <h3 v-if="title" class="section-heading">
      {{ title }} <span class="label">{{ count }}</span>
    </h3>
    <component :is="padletCollectionView" :walls="walls" :folder="folder" :sort-by="sortBy" :actions="actions" />
  </section>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import PadletList from './padlet_list'
import PadletCards from './padlet_cards'
import device from 'bits/device'
export default {
  components: { PadletList, PadletCards },
  props: {
    folder: {},
    walls: {
      default: [],
    },
    sortBy: {
      default: 'updatedAt',
    },
    title: {},
    actions: {
      default: false,
    },
  },
  computed: {
    count: function() {
      return this.walls.length
    },
    padletCollectionView() {
      return this.isPhone || device.phone ? 'padlet-list' : 'padlet-cards'
    },
  },
}
</script>
